(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nav-category"] && !Shopify.designMode) return;
  try {
    // ---------------------------------------------------------------------------
// Nav-category block JS (Shopify deduplicates this — runs once per page).
//
// Responsibilities:
//   1. --nav-bottom CSS var for desktop dropdown positioning
//   2. Desktop keyboard accessibility (Enter/Space/Escape/Tab)
//   3. Clone desktop nav blocks into mobile submenu containers
//
// Mobile menu open/close and submenu slide-in/back are handled by header.js.
// See theme/scripts/sections/header.js for the consolidated navigation JS.
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('[data-nav-category]')?.closest('nav')
  if (!nav) return

  // -------------------------------------------------------------------------
  // Desktop dropdown positioning via --nav-bottom CSS var
  // -------------------------------------------------------------------------
  const updateNavBottom = () => {
    document.documentElement.style.setProperty('--nav-bottom', `${nav.getBoundingClientRect().bottom}px`)
  }

  updateNavBottom()
  window.addEventListener('scroll', updateNavBottom, { passive: true })
  window.addEventListener('resize', updateNavBottom)

  // -------------------------------------------------------------------------
  // Desktop keyboard accessibility
  // -------------------------------------------------------------------------

  /** Set tabindex on all focusable elements inside a dropdown. */
  const setDropdownTabIndex = (dropdown, value) => {
    for (const el of dropdown.querySelectorAll('a, button')) {
      el.setAttribute('tabindex', value)
    }
  }

  // Remove dropdown links from tab order by default on desktop
  if (window.innerWidth > 1023) {
    for (const el of document.querySelectorAll('.desktop-dropdown a, .desktop-dropdown button')) {
      el.setAttribute('tabindex', '-1')
    }
  }

  for (const button of document.querySelectorAll('[data-nav-category] [data-mobile-toggle]')) {
    const dropdownId = button.getAttribute('aria-controls')
    const dropdown = document.getElementById(dropdownId)
    if (!dropdown) continue

    // Category button: Enter/Space toggles dropdown, Escape closes
    button.addEventListener('keydown', (e) => {
      if (e.ctrlKey || e.metaKey) return // Ctrl+Tab skips menus
      if (window.innerWidth <= 1023) return // Mobile handled by header.js

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        const wasExpanded = button.getAttribute('aria-expanded') === 'true'
        button.setAttribute('aria-expanded', wasExpanded ? 'false' : 'true')
        setDropdownTabIndex(dropdown, wasExpanded ? '-1' : '0')

        if (!wasExpanded) {
          requestAnimationFrame(() => {
            dropdown.querySelector('a, button, [tabindex]:not([tabindex="-1"])')?.focus()
          })
        }
      }

      if (e.key === 'Escape') {
        button.setAttribute('aria-expanded', 'false')
        setDropdownTabIndex(dropdown, '-1')
        button.focus()
      }
    })

    // Dropdown: Escape closes and returns focus to category button
    dropdown.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        button.setAttribute('aria-expanded', 'false')
        setDropdownTabIndex(dropdown, '-1')
        button.focus()
      }

      // Tab forward: close dropdown and move to next category
      if (e.key === 'Tab' && !e.shiftKey) {
        const parent = dropdown.closest('[data-nav-category]')
        const next = parent?.nextElementSibling?.querySelector('[data-mobile-toggle]')
        if (next) {
          e.preventDefault()
          button.setAttribute('aria-expanded', 'false')
          setDropdownTabIndex(dropdown, '-1')
          next.focus()
        }
      }
    })

    // Close dropdown when focus leaves entirely
    dropdown.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        const parent = dropdown.closest('[data-nav-category]')
        if (!parent?.contains(document.activeElement)) {
          button.setAttribute('aria-expanded', 'false')
          setDropdownTabIndex(dropdown, '-1')
        }
      })
    })
  }

  // -------------------------------------------------------------------------
  // Clone desktop nav blocks into mobile submenu containers (once)
  // -------------------------------------------------------------------------
  let mobileClonesCreated = false

  function ensureMobileClones() {
    if (mobileClonesCreated || window.innerWidth > 1023) return

    for (const category of document.querySelectorAll('[data-nav-category]')) {
      const desktop = category.querySelector('.desktop-blocks-container')
      const mobile = category.querySelector('.mobile-blocks-container')
      if (!desktop || !mobile || mobile.children.length > 0) continue

      for (const child of desktop.children) {
        mobile.appendChild(child.cloneNode(true))
      }
    }
    mobileClonesCreated = true
  }

  ensureMobileClones()
  window.addEventListener('resize', ensureMobileClones)

  // -------------------------------------------------------------------------
  // Desktop↔mobile viewport transition cleanup
  // -------------------------------------------------------------------------
  let lastMode = window.innerWidth <= 1023 ? 'mobile' : 'desktop'

  window.addEventListener('resize', () => {
    const currentMode = window.innerWidth <= 1023 ? 'mobile' : 'desktop'
    if (currentMode === lastMode) return
    lastMode = currentMode

    if (currentMode === 'desktop') {
      // Switched to desktop — reset any lingering mobile submenu state
      window.resetMobileMenuState?.()
    }

    // Reset ARIA for all category buttons
    for (const btn of document.querySelectorAll('[data-nav-category] [data-mobile-toggle]')) {
      btn.setAttribute('aria-expanded', 'false')
    }
  })
})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-column"] && !Shopify.designMode) return;
  try {
    // ---------------------------------------------------------------------------
// Nav-column block JS (Shopify deduplicates this — runs once per page).
//
// Responsibility: mobile column-heading accordion toggles within submenu panels.
// Uses event delegation so cloned elements (desktop → mobile) work automatically
// without rebinding or MutationObservers.
//
// Desktop dropdown keyboard nav (Escape from column links → category button)
// is handled by nav-category.liquid's {% javascript %} block.
// Mobile menu open/close and submenu slide-in/back are in header.js.
// ---------------------------------------------------------------------------

// Mobile column heading accordion — event delegation (works on cloned elements)
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-mobile-column-toggle]')
  if (!toggle || window.innerWidth > 1023) return

  e.stopPropagation()
  const column = toggle.closest('.nav-column')
  const links = column?.querySelector('.nav-column-links')
  if (!links) return

  const isActive = toggle.classList.contains('active')
  toggle.classList.toggle('active', !isActive)
  toggle.setAttribute('aria-expanded', String(!isActive))

  // Toggle link visibility — CSS has !important rules for .active + .nav-column-links,
  // but inline styles ensure cloned elements (which may miss the CSS cascade) also work.
  links.style.cssText = isActive
    ? ''
    : 'display: block !important; opacity: 1 !important; visibility: visible !important;'
}, true) // capture phase to match existing behavior

// Keyboard support for column toggle headings
document.addEventListener('keydown', (e) => {
  const toggle = e.target.closest('[data-mobile-column-toggle]')
  if (!toggle) return
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault()
    toggle.click()
  }
})
  } catch(e) { console.error(e); }
})();

})();
